import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';

import { useGetAppetiteById } from '@/hooks/queries';
import { getFriendlyId } from '@/utils/friendlyId';

type Props = {
  appetiteId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ appetiteId }) => {
  const { data } = useGetAppetiteById(appetiteId ?? '', !appetiteId);

  return (
    <>
      {getFriendlyId(
        Parent_Type_Enum.Appetite,
        data?.appetite?.[0]?.SequentialId
      ) || ''}
    </>
  );
};

export default Breadcrumb;
